import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  viewBox: "0 0 25 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m7.54 11.08 1.44 1.2c1.837 1.53 2.755 2.295 3.841 2.295s2.005-.765 3.841-2.295l1.44-1.2c.353-.295.53-.442.625-.644.094-.201.094-.432.094-.892V7.48q0-.48-.002-.898c-.011-1.77-.098-2.737-.73-3.37-.732-.732-1.91-.732-4.268-.732h-2c-2.357 0-3.535 0-4.268.733-.632.632-.72 1.598-.732 3.37q-.002.417 0 .897v2.064c0 .46 0 .69.095.892.094.202.27.35.625.644m2.531-4.6a.75.75 0 0 1 .75-.75h4a.75.75 0 1 1 0 1.5h-4a.75.75 0 0 1-.75-.75m1 3a.75.75 0 0 1 .75-.75h2a.75.75 0 1 1 0 1.5h-2a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m8.98 12.28-1.44-1.2c-.354-.294-.531-.442-.625-.643-.095-.202-.095-.432-.095-.893V6.582c-1.3.128-2.175.417-2.828 1.07C2.82 8.824 2.82 10.71 2.82 14.482c0 3.77 0 5.656 1.172 6.828s3.057 1.172 6.828 1.172h4c3.771 0 5.657 0 6.829-1.172s1.171-3.057 1.171-6.828 0-5.658-1.171-6.83c-.654-.653-1.53-.942-2.83-1.07l.001.899v2.063c0 .46 0 .69-.094.893-.095.201-.272.349-.625.643l-1.44 1.2c-1.836 1.53-2.755 2.296-3.84 2.296-1.087 0-2.005-.766-3.842-2.296",
      opacity: ".5"
    }, null, -1)
  ])))
}
export default { render: render }